export default "__VITE_ASSET__DDm3LEZF__"